export const SET_WATCHES = 'SET_WATCHES'
export const SET_WATCH_DRAWER_OPEN = 'SET_WATCH_DRAWER_OPEN'
